import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { isSafePath } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { cancelAppointmentConfirmationScreenEvent } from '../../../../data-layer/actions.js';
import '../../../../types/Forms.js';
import { AppointmentCommunicationChannel } from '../../../../types/shared.js';
import { fromArrayToString } from '../../../../utils/from-array-to-string.js';
import '@grandvisionhq/graphql';
import '@swc/helpers';
import { useCancelAppointmentContext } from '../../context/context.js';
import { useRoutingContext } from '../../context/RoutingContext/context.js';
import CancelAppointmentConfirmation from './CancelAppointmentConfirmation.js';

const CancelAppointmentConfirmationContainer = ()=>{
    const { appointment , store  } = useCancelAppointmentContext();
    const { getLabel , getFormattedLabel  } = useIntl();
    const [, { queryParams: { returnPath , returnLabel  } ,  }, ] = useRoutingContext();
    var ref5;
    const labels = React.useMemo(()=>{
        var ref2;
        return {
            title: getFormattedLabel('appointments.page.cancel.confirm.title', {
                labelData: {
                    name: (ref5 = appointment === null || appointment === void 0 ? void 0 : (ref2 = appointment.invitee) === null || ref2 === void 0 ? void 0 : ref2.firstName) !== null && ref5 !== void 0 ? ref5 : ''
                }
            }),
            subtitle: getLabel('appointments.page.cancel.confirm.subtitle'),
            notification: (appointment === null || appointment === void 0 ? void 0 : appointment.preferredChannelOfCommunication) === AppointmentCommunicationChannel.EMAIL ? getLabel(`appointments.page.cancel.confirm.notification.email`) : getLabel('appointments.page.cancel.confirm.notification.sms'),
            returnLabel: getLabel('appointments.page.cancel.confirm.closeButtonLabel.backHome')
        };
    }, [
        appointment,
        getLabel,
        getFormattedLabel
    ]);
    React.useEffect(()=>{
        if (appointment && store) {
            var ref, ref3;
            var ref4;
            const dataLayerEvent = cancelAppointmentConfirmationScreenEvent({
                appointment: {
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: {
                        id: ((ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) || '',
                        ageGroup: (ref4 = (ref3 = appointment.appointmentType) === null || ref3 === void 0 ? void 0 : ref3.ageGroup) !== null && ref4 !== void 0 ? ref4 : 'ADULT'
                    }
                },
                store: store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointment,
        store
    ]);
    if (!appointment) {
        // TODO: add empty screen in scope of the ticket https://jira.grandvision.global/browse/GAAB-3886
        return null;
    }
    var ref1;
    return /*#__PURE__*/ React.createElement(CancelAppointmentConfirmation, {
        labels: labels,
        appointment: appointment,
        store: store,
        returnLabel: (ref1 = fromArrayToString(returnLabel)) !== null && ref1 !== void 0 ? ref1 : labels.returnLabel,
        returnPath: (()=>{
            var ref;
            const rawReturnPath = (ref = fromArrayToString(returnPath)) !== null && ref !== void 0 ? ref : '/';
            return isSafePath(rawReturnPath) ? rawReturnPath : '/';
        })()
    });
};

export { CancelAppointmentConfirmationContainer as default };
//# sourceMappingURL=CancelAppointmentConfirmationContainer.js.map
